import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class RecordStatusApi<RecordStatus> extends BaseAPI {
  // constructor() {}

  public getRecordStatuses: () => Promise<RecordStatus[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/RecordStatus`)).data.output;
  };
}

export const recordStatusAPI = new RecordStatusApi();
